// web/src/api/utility/UtilityAPI.ts
import { AxiosInstance } from 'axios';

export default class UtilityAPI {
  client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async getSearchSuggestions(query: string) {
    return this.client.get(`/utility/global-search/?search_value=${query}`);
  }
}
